<template>
  <v-app id="app">
    <v-app-bar app light>
     <v-btn text dark :ripple="false" depressed retain-focus-on-click @click="goHome()" class="pr-0 mr-0"><v-img :src="$store.state.config.logo.src" max-width="185px" height="110px" position="left 0" contain class="mt-0 pt-0"></v-img></v-btn>
     <br><v-img :src="$store.state.config.selo1.src" height="55px" width="171px" position="left center" contain class="mt-9"></v-img>
    <v-spacer></v-spacer>
      <!-- <v-app-bar-nav-icon/> -->
      <v-toolbar-items v-if="$store.state.showMenu">
        <v-btn text small class="font-weight-light" to="/planos" @click="$store.commit('toggleMenu','show')">Meus Planos</v-btn>
        <v-btn text small class="font-weight-light" to="/relatorios" @click="$store.commit('toggleMenu','show')">Relatórios</v-btn>
        <v-btn text small class="font-weight-light" to="/boletos" @click="$store.commit('toggleMenu','show')">2ª Via de Boletos</v-btn>
        <v-btn text small class="font-weight-light" to="/carteirinha" @click="$store.commit('toggleMenu','show')">2ª Via de Carteirinhas</v-btn>
        <v-btn text small class="font-weight-light" to="/dadoscadastrais" @click="$store.commit('toggleMenu','show')">Dados cadastrais</v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon small v-on="on" @click="$store.dispatch('request/logout')">
              <v-icon>fal fa-sign-out</v-icon>
            </v-btn>
          </template>
          <span>SAIR</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>

    <v-content>
      <v-container
        id="appContainer"
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col class="text-center">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <!-- <v-footer
        color="white"
        app
        min-height="50px"
      >
      <v-spacer></v-spacer>
      <span class="black--text"></span>
    </v-footer> -->
    <loader
      :loaderOn="loaderOn"
      :linearLoader="$store.state.loader.linearLoader"
      :circleLoader="$store.state.loader.circleLoader"
    ></loader>
    <snackbar
      :timeout="$store.state.snack.timeout"
      :snackMessage="$store.state.snack.snackMessage"
      :typeSnack="$store.state.snack.typeSnack"
    ></snackbar>
    <confirm-message
      :message="$store.state.confirmMessage.message"
      :title="$store.state.confirmMessage.title"
      :type="$store.state.confirmMessage.type"
      :btConfirm="$store.state.confirmMessage.btConfirm"
      :btCancel="$store.state.confirmMessage.btCancel"
      :callback="$store.state.confirmMessage.callback"
    ></confirm-message>
  </v-app>
</template>

<script>
// @ is an alias to /src
import loader from "./components/common/Loader";
import snackbar from "./components/common/Alerts";
import confirmMessage from "./components/common/ConfirmMessage";

export default {
  data: () => ({
    drawer: null
  }),
  props: {
    source: String
  },
  components: {
    loader,
    snackbar,
    confirmMessage
  },
  created() {
    let router = this.$router
    this.$store.dispatch("request/verifyAuth").then(resp => {
      if(resp) {
        if(router.history.pending && router.history.pending.path && router.history.pending.path != "/") {
          this.$store.commit('toggleMenu','show')
          router.push(router.history.pending.path)
        } else {
          this.$store.commit('toggleMenu','hide')
          router.push('/')
        }
      } else if (router.history.current && router.history.current.path == "/2aviaboletos" || router.history.current.path == "/cadastro" ) {
        this.$store.commit('toggleMenu','hide')
      } else if (router.history.pending && router.history.pending.path == "/2aviaboletos" || router.history.pending.path == "/cadastro" ) {
        this.$store.commit('toggleMenu','hide')
      } else {
        this.$store.commit('toggleMenu','hide')
        router.push("/login")
      }
    })
  },
  computed: {
    loaderOn: function() {
      return this.$store.state.loader.loaderOn;
    }
  },
  methods: {
    goHome(){
      this.$store.commit('toggleMenu','hide')
      this.$store.dispatch("request/verifyAuth").then(resp => {
        if(!resp ){
          this.$store.commit('toggleMenu','hide')
          this.$router.push("/login")
        } else {
           this.$router.push("/")
        }
      })
    }
  }
};
</script>

<style>
#appContainer {
  background: url('../public/img/bg1.jpg');
  background-size: cover
}
.plan-card.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 10px;
}
</style>
